import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const getEmailTemplatesByTeam = {
  input: z.object({
    teamId: zExt.objectId(),
    sortDirection: z.nativeEnum(SortDirection).optional(),
  }),
  output: z.object({ data: z.array(emailTemplateSchema) }),
};
